export const countDown = {
  dayText: 'DAYS',
  hoursText: 'HOURS',
  title: 'START IN:',
  minutesText: 'MINUTES',
  now: 'NOW'
};
